import { History } from 'history';
import { useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { ScrollToHelper } from '../Helpers/ScrollToHelper';

function ScrollTo(props: RouteComponentProps<any>) {
    const history: History = props.history;
    useEffect(() => {
        const unlisten = history.listen(() => {
            ScrollToHelper.scrollToAnchor();
        });
        return () => {
            unlisten();
        };
    }, [history]);

    return null;
}

export default withRouter(ScrollTo);
